export { default } from './app-bar.component';

const addToSite = [
  { type: 'equipment', text: 'Equipment', iconType: 'fill' },
  { type: 'inspection', text: 'Inspection', iconType: 'stroke' },
  { type: 'work-order', text: 'Work request', iconType: 'stroke' },
  { type: 'work-order', text: 'Work order', iconType: 'stroke' },
  { type: 'check', text: 'Check', iconType: 'stroke' },
  { type: 'hse-event', text: 'HSE event', iconType: 'stroke' }
];
const addToStructure = addToSite.filter(({ type }) => type === 'work-order' || type === 'check');
const addToEquipment = addToSite.filter(
  ({ type }) => type === 'inspection' || type === 'work-order' || type === 'check'
);

const addToSite1 = [
  { type: 'equipment', text: 'Equipment', iconType: 'fill' },
  { type: 'inspection', text: 'Inspection', iconType: 'stroke' },
  { type: 'work-order', text: 'Work order', iconType: 'stroke' },
  { type: 'work-order', text: 'Work request', iconType: 'stroke' },
  { type: 'check', text: 'Check', iconType: 'stroke' },
  { type: 'hse-event', text: 'HSE event', iconType: 'stroke' }
];

export const addToOptions = {
  site: addToSite1,
  'parent site': addToSite1,
  structure: addToStructure,
  equipment: addToEquipment,
  'parent equipment': addToEquipment,
  pipeline: addToEquipment,
  default: addToSite
};
